import { useSelector } from 'react-redux';
import useSessionUser from '../../../hooks/useSessionUser';
import { FolderMessageContent, Message, foldersWithHelpdesk } from '../../../models/communication.types';
import { RootState } from '../../../store';
import { TableMessageParticipant } from './MessagesList.types';
import { getParticipantDisplayName, getTableParticipant } from './utils';

interface MessageParticipantCellProps {
  message: Message | FolderMessageContent;
  revert?: boolean;
  isMessageContentView?: boolean;
}

const MessageParticipantLabel: React.FC<MessageParticipantCellProps> = ({ message, revert, isMessageContentView }) => {
  const activeFolder = useSelector((state: RootState) => state.mailbox.activeFolder);
  const user = useSessionUser();

  const isHelpDeskFolder = foldersWithHelpdesk.includes(activeFolder);

  const recipient = `Do: ${
    message.sender && message.sender.firstName !== null && message.sender.firstName === 'Helpdesk'
      ? 'Helpdesk'
      : getParticipantDisplayName(message.recipient)
  }`;
  const sender = isHelpDeskFolder && !isMessageContentView! ?
   'Helpdesk'
   : `Od: ${ getParticipantDisplayName(message.sender)}` 

  const participantInfo = getTableParticipant(activeFolder, user.user, message);
  let selector = participantInfo === TableMessageParticipant.sender;

  if (revert) {
    selector = !selector;
  }
  return <>{selector ? sender : recipient}</>;
};

export default MessageParticipantLabel;
